import * as THREE from "three";
import { BuildingData } from "../types";

const DEG2RAD = Math.PI / 180;

export function createBuilding(data: BuildingData): THREE.Group {
  const group = new THREE.Group();

  const shape = new THREE.Shape();
  const fp = data.footprint;
  shape.moveTo(fp[0][0], fp[0][1]);
  for (let i = 1; i < fp.length; i++) {
    shape.lineTo(fp[i][0], fp[i][1]);
  }
  shape.closePath();

  for (const hole of data.holes) {
    if (hole.type === "arc") {
      const path = new THREE.Path();
      path.absarc(
        hole.center[0],
        hole.center[1],
        hole.radius,
        hole.startAngle * DEG2RAD,
        hole.endAngle * DEG2RAD,
        false
      );
      shape.holes.push(path);
    }
  }

  const geo = new THREE.ExtrudeGeometry(shape, {
    depth: data.height,
    bevelEnabled: false,
  });
  geo.computeVertexNormals();

  const mat = new THREE.MeshStandardMaterial({
    color: new THREE.Color(data.color),
    roughness: 0.7,
    metalness: 0.0,
  });

  const mesh = new THREE.Mesh(geo, mat);
  mesh.rotation.x = -Math.PI / 2;
  mesh.castShadow = true;
  mesh.receiveShadow = true;
  group.add(mesh);

  group.position.set(...data.position);
  group.rotation.set(
    data.rotation[0] * DEG2RAD,
    data.rotation[1] * DEG2RAD,
    data.rotation[2] * DEG2RAD
  );

  return group;
}
